import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ValidMe } from '../../../../businessLogic/validation.js';
import { getWaitingAreaNameToShortURL } from '../../../../businessLogic/selfProvision';
import Txt from '../../../inputs/textInput.js';
import { setWASelfProvisionForm, setWASelfProvisionFormTrim } from '../../../../actions/waitingArea.js';
import objectAssign from 'object-assign';

export default function CenterPanel(props) {
  const dispatch = useDispatch();
  const orgNameAbbRef = useRef(null);
  const waitingAreaURLRef = useRef(null);
  const [isOnMobileOrTablet, setIsOnMobileOrTablet] = useState(
    window.innerWidth < window.styleVariable.computerMinWidth
  );

  useEffect(() => {
    //register the delegate event
    window.addEventListener('globalMessageHidden', globalMessageHidden);
    window.addEventListener('resize', handleOnScreenSizeUpdate);

    return () => {
      ////unRegister the delegate event
      window.removeEventListener('globalMessageHidden', globalMessageHidden);
      window.removeEventListener('resize', handleOnScreenSizeUpdate);
    };
  }, []);

  //this function is a delegate event, and is fired when global message is hidden
  const globalMessageHidden = (e) => {
    if (e.detail && e.detail.text.indexOf('Organisation with that name') > 0) {
      window.$('input[name="orgName"]').focus();
    } else if (e.detail && e.detail.text.indexOf('Waiting Area with that URL') > 0) {
      window.$('input[name="waitingAreaUrl"]').focus();
    }
  };

  const onSelfProvisionElementBlur = () => {
    dispatch(setWASelfProvisionFormTrim());
  };
  const organisationNameChanged = (value) => {
    dispatch(setWASelfProvisionForm(selfProvisionFormUpdated('organisationName', value)));
  };
  const organisationAbbreviationChanged = (value) => {
    dispatch(setWASelfProvisionForm(selfProvisionFormUpdated('organisationAbbreviation', value)));
  };
  const waitingAreaNameChanged = (value) => {
    dispatch(setWASelfProvisionForm(selfProvisionFormUpdated('waitingAreaName', value)));
  };
  const waitingAreaURLChanged = (value) => {
    // Replace all forward slashes with single forward slash
    value = value.replace(/[\/]{1,}/g, '/');
    dispatch(setWASelfProvisionForm(selfProvisionFormUpdated('waitingAreaUrl', value)));
  };
  const orgNameFocusOut = (value) => {
    onSelfProvisionElementBlur();
    //on focus out we will have to copy it to org abb field if the conditions are met
    if (
      !(
        props.selfProvisionCreateForm.organisationAbbreviation &&
        props.selfProvisionCreateForm.organisationAbbreviation.length > 0
      ) &&
      value.length > 2 &&
      value.length <= 16
    ) {
      dispatch(setWASelfProvisionForm(selfProvisionFormUpdated('organisationAbbreviation', value)));
      setTimeout(() => {
        //we fire the handle change after 300 ms, as by that time the field values would have taken place
        //The validation does not kick in, so this helps
        orgNameAbbRef.wrappedInstance.handleChange(value);
      }, 300);
    }
  };
  const waNameFocusOut = (value) => {
    onSelfProvisionElementBlur();
    if (
      (!props.selfProvisionCreateForm.waitingAreaUrl || props.selfProvisionCreateForm.waitingAreaUrl.length == 0) &&
      value.length > 0 &&
      value.length <= 50
    ) {
      let shortUrl = getWaitingAreaNameToShortURL(value);
      dispatch(setWASelfProvisionForm(selfProvisionFormUpdated('waitingAreaUrl', shortUrl)));
      setTimeout(() => {
        //we fire the handle change after 300 ms, as by that time the field values would have taken place
        //The validation does not kick in, so this helps
        waitingAreaURLRef.wrappedInstance.handleChange(shortUrl);
      }, 300);
    }
  };
  const selfProvisionFormUpdated = (property, value) => {
    return objectAssign({}, props.selfProvisionCreateForm, { [property]: value });
  };

  const handleOnScreenSizeUpdate = (e, { width }) => {
    setIsOnMobileOrTablet(window.innerWidth >= window.styleVariable.computerMinWidth ? false : true);
  };

  return (
    <div className="ui form mrbml">
      <div className="pdts">
        <ValidMe
          validmefor="length@3-120"
          trim={true}
          validmemessage={APP.LANGUAGE.Errors.OrgUnitInvalidLength}
          group="selfProvisionWAForm"
        >
          <Txt
            tabIndex="1"
            maxLength={120}
            focusme="true"
            onBlur={orgNameFocusOut}
            name="orgName"
            noTitle
            value={props.selfProvisionCreateForm.organisationName}
            onChange={organisationNameChanged}
            placeholder={APP.LANGUAGE.SelfProvisionCreateWA.OrganisationName}
          />
        </ValidMe>

        <ValidMe
          validmefor="length@3-16"
          validmemessage={APP.LANGUAGE.Errors.OrgAbbreviationLength}
          trim={true}
          group="selfProvisionWAForm"
        >
          <Txt
            tabIndex="2"
            fieldClasses="mrtl"
            ref={orgNameAbbRef}
            onBlur={onSelfProvisionElementBlur}
            noTitle
            maxLength={16}
            value={props.selfProvisionCreateForm.organisationAbbreviation}
            onChange={organisationAbbreviationChanged}
            placeholder={
              isOnMobileOrTablet
                ? APP.LANGUAGE.SelfProvisionCreateWA.OrganisationAbbreviation
                : APP.LANGUAGE.SelfProvisionCreateWA.OrganisationAbbreviationDesktop
            }
          />
        </ValidMe>

        <ValidMe
          validmefor="length@3-50"
          validmemessage={APP.LANGUAGE.Errors.WaitingAreaInValidNameLength}
          trim={true}
          group="selfProvisionWAForm"
        >
          <Txt
            tabIndex="3"
            maxLength={50}
            noTitle
            value={props.selfProvisionCreateForm.waitingAreaName}
            onChange={waitingAreaNameChanged}
            placeholder={APP.LANGUAGE.SelfProvisionCreateWA.ServiceName}
            onBlur={waNameFocusOut}
          />
        </ValidMe>

        <label className=" placeholder-label no-bold mrtxs  div-like color-placeholder">
          {APP.LANGUAGE.SelfProvisionCreateWA.WaitingAreaUrl}
        </label>
        <div className="center-flex display-flex  flex-wrap">
          <div className="title-sms small-margin mrrxxs">{props.selfProvisionCreateForm.shortUrlDomain}</div>

          <ValidMe
            validmefor="shortURLPath"
            trim={true}
            group="selfProvisionWAForm"
            fieldClasses="flex-grow-fill-rest mrtxxs"
          >
            <Txt
              tabIndex="4"
              maxLength={128}
              onBlur={onSelfProvisionElementBlur}
              name="waitingAreaUrl"
              noTitle
              ref={waitingAreaURLRef}
              notRenderPlaceholderAsTitle={true}
              value={props.selfProvisionCreateForm.waitingAreaUrl}
              onChange={waitingAreaURLChanged}
              placeholder={APP.LANGUAGE.SelfProvisionCreateWA.WaitingAreaUrlPlaceHolder}
            />
          </ValidMe>
        </div>
        <div className="mrbm pdbm hide-on-small-ress " />
      </div>
    </div>
  );
}
